import React from 'react';
import { SiteClosingCta } from '../../components/site';
import { PartnerPanelLink } from '../../components/PartnerPanelLink';
import { partnerSignupUrl } from '../../config/partnerPanel';
import type { SolutionSubpageConfig } from './types';

export const SolutionClosingCta: React.FC<{
  closing: SolutionSubpageConfig['closing'];
}> = ({ closing }) => (
  <div className="platform-closing-wrap">
    <SiteClosingCta
      titleId="solution-closing-title"
      titleLines={closing.titleLines}
      subtitle={closing.subtitle}
      ctaAction={
        <PartnerPanelLink to={partnerSignupUrl()} className="io-home-closing__cta">
          {closing.ctaLabel}
        </PartnerPanelLink>
      }
    />
  </div>
);
